// Coordinationモーダルで利用する独自処理
// DawnのModalDialogクラスを踏襲しつつ一部カスタマイズ
class CustomCoordinationModalDialog extends HTMLElement {
  constructor() { 
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    // Coordinationモーダルはbody直下に移動させないためコメントアウト
    //document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('custom-overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));

    // 要素の動的な位置調整
    const btnPosition = (100 - ((this.querySelector('[role="dialog"]').clientHeight / this.clientHeight) * 100)) / 2;
    this.querySelector('.c-quick-view-modal__toggle').style.top = 'calc(' + btnPosition + '% - 4.2rem)';
    this.querySelector('.c-quick-view-modal__toggle').classList.remove('hidden');

    // SPにおける文字数省略
    const dialog = this.querySelector('[role="dialog"]'),
          dialogMaxHeight = dialog.clientHeight,
          dialogInnerHeight = 60 + dialog.querySelector('.product__info-header').clientHeight + 16 + 156 + 66,
          description = dialog.querySelector('.product__description'),
          descriptionAllowHeight = dialogMaxHeight - dialogInnerHeight,
          descriptionAllowLine = (Math.floor(descriptionAllowHeight / (13 * 1.6))); 

    const mediaQuery = window.matchMedia('(max-width: 749px)');
    if (mediaQuery.matches) {
      description.style['-webkit-line-clamp'] = descriptionAllowLine;
    } else {
      description.removeAttribute('style');
    }
  }

  hide() {
    document.body.classList.remove('custom-overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);

    const description = this.querySelector('[role="dialog"] .product__description');
    if (description.hasAttribute('style')) {
      description.removeAttribute('style');
    }
  }
}
customElements.define('c-quick-view-modal', CustomCoordinationModalDialog);